var toUnit = function toUnit() {
  var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'px';
  return function (value) {
    return Number(value) && value !== 0 ? "".concat(value).concat(unit) : value;
  };
};

var toPx = toUnit('px');
export { toUnit, toPx };